var MESSAGE_NO_CARD_DEFAULT = "Il n'y a plus de cartes à montrer.";
var ATTR_NO_CARD_MSG = "data-clientside-no-cards-message";
var ATTR_CHILDREN_INDEX = "data-clientside-children-number";

function Cardlist(element) {
    this.element = element;
}

Cardlist.prototype.showNoCardMessage = function () {
    this.element.children[0].innerHTML = buildHTMLTitle(
        getNoCardMessage.call(this)
    );
};

Cardlist.prototype.hasExpectedChildrenIndex = function () {
    return (
        this.element.parentNode.childElementCount ===
        Number(getChildrenIndex.call(this))
    );
};

function buildHTMLTitle(message) {
    return "<h3>" + message + "</h3>";
}

function getNoCardMessage() {
    return this.element.getAttribute(ATTR_NO_CARD_MSG) || MESSAGE_NO_CARD_DEFAULT;
}

function getChildrenIndex() {
    return this.element.getAttribute(ATTR_CHILDREN_INDEX);
}

export default Cardlist;



// WEBPACK FOOTER //
// ./src/js/cms/commons/clientCustomizer/CardList.js